/**
 * Utility to reliably extract an array of user objects from diverse API payload shapes.
 * Handles arrays, wrapped objects ({ users: [] }, { data: [] }, { records: [] }), and dict objects.
 */
export const extractUserList = (rawData) => {
  if (!rawData) return [];
  if (Array.isArray(rawData)) return rawData;
  if (Array.isArray(rawData.users)) return rawData.users;
  if (Array.isArray(rawData.data)) return rawData.data;
  if (Array.isArray(rawData.records)) return rawData.records;
  if (Array.isArray(rawData.items)) return rawData.items;
  if (typeof rawData === 'object' && rawData !== null) {
    const values = Object.values(rawData);
    if (values.length > 0 && Array.isArray(values[0])) {
      return values[0];
    }
    return values.filter((item) => item && typeof item === 'object');
  }
  return [];
};
